import { ensureNegative, round } from '@shared/utils/math';

export const sanitizeNumber = (number: number | string | null | undefined, negative = false) => {
	if (number == null) {
		return 0;
	}

	if (typeof number === 'string') {
		number = parseFloat(number);
	}

	if (Number.isNaN(number)) {
		return 0;
	}

	if (!Number.isFinite(number)) {
		return 0;
	}

	if (negative) {
		number = ensureNegative(number);
	}

	return number;
};

export const shortenNumber = (number: number) => {
	if (number >= 1_000_000) {
		return `${round(number / 1_000_000, 2)}M`;
	}

	return `${round(number / 1_000, 2)}K`;
};

// @ts-ignore
export const isValidNumber = (string: string) => !isNaN(parseFloat(string)) && isFinite(string);

export const isMissingOrZero = (value: number | null | undefined) => value == null || value === 0;
